import React, { useEffect } from 'react';
import { AdProps } from '../../lib/ads/types';
import { AD_CONFIG, isTestMode } from '../../lib/ads/config';

export default function AdSpace({ location, className = '' }: AdProps) {
  const config = AD_CONFIG[location];

  useEffect(() => {
    if (!isTestMode && config) {
      // Initialize AdSense ads
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } catch (error) {
        console.error('Error initializing AdSense:', error);
      }
    }
  }, [location]);

  if (!config) return null;

  if (isTestMode) {
    return (
      <div 
        className={`flex items-center justify-center ${className}`}
        style={{ backgroundColor: config.testColor }}
      >
        <span className="text-gray-600 text-sm text-center p-4">
          {config.testText}
        </span>
      </div>
    );
  }

  return (
    <div className={className}>
      <ins
        className="adsbygoogle"
        style={{ display: 'block', width: '100%', height: '100%' }}
        data-ad-client={config.adsenseId}
        data-ad-slot={config.adSlot}
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
}